import { EncodingOperation } from "namirasoft-core";

export class PaymentRoutes
{
    static handleCallback(url: string, search: boolean, callback: string)
    {
        let ans = url;
        if (search)
            if (callback)
                ans += `?callback=${EncodingOperation.Base64Encode(callback)}`;
            else
                ans += window.location.search;
        return ans;
    }
    static Home = "/";

    // Subscription
    static SubscriptionList(search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/subscription/list`, search, callback);
    }
    static SubscriptionView(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/subscription/${id}/view`, search, callback);
    }
    static SubscriptionCancellation(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/subscription/${id}/cancellation`, search, callback);
    }
    static SubscriptionCancellationOffer(id: string, offer_id: string, cancellation_reason_id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/subscription/${id}/cancellation/offer/${offer_id}/reason/${cancellation_reason_id}`, search, callback);
    }
    static SubscriptionCancellationConfirmation(id: string, cancellation_reason_id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/subscription/${id}/cancellation/confirmation/reason/${cancellation_reason_id}`, search, callback);
    }
    static SubscriptionCancellationResult(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/subscription/${id}/cancellation/result`, search, callback);
    }
    static SubscriptionCanceled(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/subscription/${id}/canceled`, search, callback);
    }
    static SubscriptionSuccessful(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/subscription/${id}/successful`, search, callback);
    }

    // Invoice
    static InvoiceList(search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/invoice/list`, search, callback);
    }
    static InvoiceGateway(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/invoice/${id}/gateway`, search, callback);
    }
    static InvoiceView(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/invoice/${id}/view`, search, callback);
    }

    // Payment
    static PaymentList(search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/payment/list`, search, callback);
    }
    static PaymentCanceled(search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/payment/canceled`, search, callback);
    }
    static PaymentSuccessful(search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/payment/successful`, search, callback);
    }
    static PaymentView(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/payment/${id}/view`, search, callback);
    }

    //Product
    static ProductList(search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/product/list`, search, callback);
    }

    //Sales Items
    static SalesItemList(product_slug: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/sales/item/list/${product_slug}`, search, callback);
    }
    static SalesItemView(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/sales/item/${id}/view`, search, callback);
    }

    // Offer
    static OfferList(product_slug: string, sales_item_slug: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/offer/list/${product_slug}/${sales_item_slug}`, search, callback);
    }
    static OfferListOne(product_slug: string, sales_item_slug: string, offer_id: string | null, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/offer/list/${product_slug}/${sales_item_slug}/${offer_id}`, search, callback);
    }
    static OfferView(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/offer/${id}/view`, search, callback);
    }
    static OfferItemView(id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/offer/item/${id}/view`, search, callback);
    }
    static OfferGateway(product_slug: string, sales_item_slug: string, id: string, search: boolean, callback: string)
    {
        return PaymentRoutes.handleCallback(`/offer/${product_slug}/${sales_item_slug}/${id}/gateway`, search, callback);
    }
}